import { render, staticRenderFns } from "./UpdateFxInvestPurpose.vue?vue&type=template&id=34530a21&scoped=true"
import script from "./UpdateFxInvestPurpose.vue?vue&type=script&lang=js"
export * from "./UpdateFxInvestPurpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34530a21",
  null
  
)

export default component.exports